module.exports = "/images/united_nations.svg?d76839646bedfdd389339cbdd5ad06db";